import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="py-12 px-6 border-t border-border bg-card/50" role="contentinfo">
      <div className="container mx-auto max-w-7xl">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-8">
          {/* Contact info */}
          <div>
            <h3 className="text-xl font-bold mb-4">
              <span className="text-gradient">DigiAd</span>Words
            </h3>
            <address className="not-italic space-y-3">
              <div className="flex items-center gap-3 text-muted-foreground">
                <Mail className="w-5 h-5 text-primary" aria-hidden="true" />
                <a href="mailto:digiadwords247@gmail.com" className="hover:text-primary transition-colors">digiadwords247@gmail.com</a>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground">
                <Phone className="w-5 h-5 text-primary" aria-hidden="true" />
                <a href="tel:+916269462158" className="hover:text-primary transition-colors">+91 6269462158</a>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground">
                <MapPin className="w-5 h-5 text-primary" aria-hidden="true" />
                <span>Online & In-Person Sessions</span>
              </div>
            </address>
          </div>

          {/* Quick links */}
          <nav aria-label="Quick links">
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/courses" className="text-muted-foreground hover:text-primary transition-colors">Courses</Link></li>
              <li><Link to="/curriculum" className="text-muted-foreground hover:text-primary transition-colors">Curriculum</Link></li>
              <li><Link to="/pricing" className="text-muted-foreground hover:text-primary transition-colors">Pricing</Link></li>
              <li><Link to="/success-stories" className="text-muted-foreground hover:text-primary transition-colors">Success Stories</Link></li>
              <li><Link to="/free-workshop" className="text-muted-foreground hover:text-primary transition-colors">Free Workshop</Link></li>
              <li><Link to="/faq" className="text-muted-foreground hover:text-primary transition-colors">FAQs</Link></li>
              <li><Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">Blog</Link></li>
              <li><Link to="/digital-marketing-gwalior" className="text-muted-foreground hover:text-primary transition-colors">Digital Marketing Gwalior</Link></li>
              <li><Link to="/register" className="text-muted-foreground hover:text-primary transition-colors">Register</Link></li>
              <li><Link to="/sitemap" className="text-muted-foreground hover:text-primary transition-colors">Sitemap</Link></li>
            </ul>
          </nav>

          {/* Programs & Resources */}
          <nav aria-label="Programs and resources">
            <h3 className="text-xl font-bold mb-4">Programs & Resources</h3>
            <ul className="space-y-2">
              <li><Link to="/summer-camp" className="text-muted-foreground hover:text-primary transition-colors">AI Summer Camp</Link></li>
              <li><Link to="/learning-library" className="text-muted-foreground hover:text-primary transition-colors">Learning Library</Link></li>
              <li><Link to="/job-preparation" className="text-muted-foreground hover:text-primary transition-colors">Job Preparation</Link></li>
              <li><Link to="/vbaip-eligibility" className="text-muted-foreground hover:text-primary transition-colors">VBAIP Eligibility</Link></li>
              <li><Link to="/awareness-test" className="text-muted-foreground hover:text-primary transition-colors">Awareness Test</Link></li>
              <li><Link to="/services" className="text-muted-foreground hover:text-primary transition-colors">Our Services</Link></li>
            </ul>
          </nav>

          {/* Newsletter */}
          <div>
            <h3 className="text-xl font-bold mb-4">Stay Updated</h3>
            <p className="text-muted-foreground mb-4">
              Get notified about upcoming workshops and AI resources
            </p>
            <form className="flex gap-2" onSubmit={(e) => e.preventDefault()}>
              <label htmlFor="footer-email" className="sr-only">Email address</label>
              <input 
                id="footer-email"
                type="email" 
                placeholder="Your email" 
                className="flex-1 px-4 py-2 rounded-full border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary text-foreground"
              />
              <button 
                type="submit"
                className="px-6 py-2 rounded-full bg-primary text-primary-foreground hover:opacity-90 transition-opacity font-medium"
                aria-label="Subscribe to newsletter"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* SEO Footer Content */}
        <div className="pt-8 border-t border-border">
          <p className="text-muted-foreground text-sm text-center mb-4">
            Digiadwords is the best Digital Marketing & AI Automation Training Institute in Gwalior, Madhya Pradesh. We offer job-oriented Digital Marketing Course in Gwalior, AI Automation Course in Gwalior, and advanced training under the Viksit Bharat AI Program. Learn SEO, Social Media Marketing, Google Ads, AI Tools, and Business Automation with live projects and placement support.
          </p>
          <p className="text-center text-muted-foreground text-sm">
            © {new Date().getFullYear()} DigiAdWords — Top Digital Marketing Institute in Gwalior. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
